const TOKEN_KEY = '__sweet-auth-token';

export function restoreAuthTokenFromLocalStorate(): string | null {
  return localStorage.getItem(TOKEN_KEY);
}

export function saveAuthTokenToLocalStorage(token: string): void {
  return localStorage.setItem(TOKEN_KEY, token);
}

export function deleteAuthTokenFromLocalStorage(): void {
  return localStorage.removeItem(TOKEN_KEY);
}
